import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  emojiIcon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '8px',
    cursor: 'pointer',
    color: '#8F8F8F'
  },

  emojiIconClickAwayContainer: {
    position: 'relative',

    '& em-emoji-picker': {
      position: 'absolute',
      zIndex: '9999',
      bottom: 15,
      left: '-25px',
      [theme.breakpoints.down('sm')]: {
        left: '-38px'
      },

      '@media (max-width: 349px)': {
        width: '98vw !important'
      }
    }
  }
}))

export default useStyles
